<template>
  <div>
    <card class="custom-shadow-card-header">
      <div class="dashboard-title">
        <strong>
          {{ $t('grow.externalquality') }}
        </strong>
      </div>
      <div class="dashboard-grid">
        <div class="chart-block chart-block--half">
          <div class="chart-inner-card">
            <div
              class="chart-body"
              v-if="showGraph && Object.keys(chartOptions[0]).length > 0"
            >
              <highcharts :options="chartOptions[0]"></highcharts>
            </div>
            <div class="chart-empty" v-else>
              {{ $t('common_words.unavailable_data') }}
            </div>
          </div>
        </div>
        <div class="chart-block chart-block--half">
          <div class="chart-inner-card">
            <div
              class="chart-body"
              v-if="showGraph && Object.keys(chartOptions[2]).length > 0"
            >
              <highcharts :options="chartOptions[2]"></highcharts>
            </div>
            <div class="chart-empty" v-else>
              {{ $t('common_words.unavailable_data') }}
            </div>
          </div>
        </div>
        <div class="chart-block chart-block--half">
          <div class="chart-inner-card">
            <div
              class="chart-body"
              v-if="showGraph && Object.keys(chartOptions[3]).length > 0"
            >
              <highcharts :options="chartOptions[3]"></highcharts>
            </div>
            <div class="chart-empty" v-else>
              {{ $t('common_words.unavailable_data') }}
            </div>
          </div>
        </div>
        <div class="chart-block chart-block--half">
          <div class="chart-inner-card">
            <div
              class="chart-body"
              v-if="showGraph && Object.keys(chartOptions[1]).length > 0"
            >
              <highcharts :options="chartOptions[1]"></highcharts>
            </div>
            <div class="chart-empty" v-else>
              {{ $t('common_words.unavailable_data') }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="card-footer footer-date-at custom-opacity">
        <p class="text-muted d-flex justify-content-between mb-0">
          <small class="ml-3">{{ $t('common_words.smart_cultivo') }}</small>
          <small class="mr-3">{{ $t('common_words.last_six_months') }}</small>
        </p>
      </div>
    </card>
  </div>
</template>
<script>
import { Chart } from 'highcharts-vue';
import { Axios } from 'src/class/Axios.js';
import exportingInit from 'highcharts/modules/exporting';
import Highcharts from 'highcharts';
import MixinCharts from 'src/util/mixinCharts';
exportingInit(Highcharts);

export default {
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      data: [],
      chartOptions: [],
      showGraph: false,
    };
  },
  mixins: [MixinCharts],
  methods: {
    getSixMonthRange() {
      const endDate = new Date();
      const startDate = new Date(endDate);
      startDate.setMonth(startDate.getMonth() - 6);

      const format = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      return {
        datei: format(startDate),
        datef: format(endDate),
      };
    },
    constructRequest() {
      const user = this.$store.getters['auth/user'];
      const date = this.getSixMonthRange();
      const business = user.business.filter((business) => business.id != 1);

      let request = { ...date };
      request.user_id = user.id;
      request.isDashboard = true;

      request.route = 'grow/externalqualityreport/getreportinfo';
      request.bySel = 'Día';
      request.farm = [];
      request.lot = [];
      request.business = business[0];

      return request;
    },
  },
  created() {
    const request = this.constructRequest();
    Axios.postMasters(request)
      .then((response) => {
        this.data = response.data.data;
        let graphs = this.data.graphs ? this.data.graphs : [];
        if (!Array.isArray(graphs)) {
          graphs = Object.values(graphs);
        }
        if (
          this.data &&
          this.data.graphs &&
          Object.keys(this.data.graphs).length > 0
        ) {
          this.chartOptions = [];
          graphs.forEach((item, index) => {
            if (item && Object.keys(item).length > 0) {
              this.$set(
                this.chartOptions,
                index,
                JSON.parse(JSON.stringify(this.graph(item))) // aqui hacemos la asignacion del metodo que vamos a usar del mixinCharts
              );
            }
          });
          console.log('chartOptions', this.chartOptions);
          this.showGraph = this.chartOptions.length > 0;
        } else {
          this.showGraph = false;
          SweetAlert.warning(i18n.t('common_words.unavailable_data'));
        }

        // Alturas opcionales para uniformidad visual
        if (this.chartOptions[0].chart) this.chartOptions[0].chart.height = 360;
        if (this.chartOptions[1].chart) this.chartOptions[1].chart.height = 360;
        if (this.chartOptions[2].chart) this.chartOptions[2].chart.height = 360;
        if (this.chartOptions[3].chart) this.chartOptions[3].chart.height = 360;
      })
      .catch(() => {
        this.showGraph = false;
      });
  },
};
</script>
<style src="./dashboard_style.css"></style>
